import {
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

const colWidths = [120, 140, 110, 180, 110, 160, 80];

interface RefundTableSkeletonProps {
  labels?: string[];
  page?: number;
  count?: number;
}

const RefundTableSkeleton = ({
  labels = [
    "Booking ID & Date",
    "Contact person",
    "Amount of refund",
    "Address to refund",
    "Request Date",
    "Cancellation Policy",
    "Action",
  ],
}: RefundTableSkeletonProps) => {
  return (
    <div className="mb-2 flex w-full flex-col overflow-hidden">
      <TableContainer className="rounded-[5px] pb-6">
        <Table stickyHeader aria-label="skeleton table">
          <TableHead>
            <TableRow>
              {labels.map((_, idx) => (
                <TableCell
                  key={idx}
                  className="h-[42px] bg-[#5248E3] py-0 text-[12px]"
                  style={{ backgroundColor: "#5248E3" }}
                >
                  <Skeleton
                    variant="text"
                    width={colWidths[idx] || 100}
                    height={24}
                    sx={{ bgcolor: "#a5a5e3", borderRadius: 1 }}
                  />
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {[...Array(5)].map((_, rowIdx) => (
              <TableRow key={rowIdx}>
                {labels.map((_, colIdx) => (
                  <TableCell
                    key={colIdx}
                    className="bg-white text-[12px] text-primary"
                  >
                    <Skeleton
                      variant="rounded"
                      width={colWidths[colIdx] || 100}
                      height={28}
                      sx={{ borderRadius: 2, mb: 0.5 }}
                      animation="wave"
                    />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default RefundTableSkeleton;
